/**
 *
 * Route definition
 * Properties:
 * - legs - array with indices - first leg always dummy with startpoint only
 * - leg_#### - Leg instance
 * - distance
 */

import Leg from './Leg';
import splice from './splice';

export default function addPoint(route, point, travelMode) {
  const legs = route.get('legs');
  const legPoints =
    legs.size === 0 ? [point] : [route.get(legs.last()).lastPoint, point];
  const leg = new Leg(legPoints, travelMode);
  const result = splice(route, legs.size, 0, leg);
  return result;
}
